module.exports = __webpack_public_path__ + "catalog/items/heating_Electrical/American-Style-Fridge/American-Style-Fridge.svg";